<template>
	<div class="subsidyDetail">
		<div class="policyAdminCon">
			<div class="head">
				<div class="title">
					<span @click="hideComponents()"><i class="el-icon-back">返回</i></span>补贴提报明细
				</div>
			</div>
			
			<div v-loading="loading" class="ul">
				<el-table :data="list" border :header-cell-style="{ background: '#51A190', color: '#FFF',borderColor:'#51A190' }">
					<el-table-column label="政策名称" prop="policy.title" align="center"/>
					<el-table-column label="补贴对象" align="center">
						<template slot-scope="scope">
							<template v-if="scope.row.company_id">
								<div>{{scope.row.company.company_name}}</div>
							</template>
							<template v-else>
								<div>{{scope.row.user.user_name}}</div>
							</template>
							<div></div>
						</template>
					</el-table-column>
					<el-table-column label="联系方式" width="160" prop="user.phone" align="center"/>
					<el-table-column label="发放金额" width="160" prop="amount" align="center"/>
					<el-table-column label="备注信息" prop="msg" align="center"/>
					<el-table-column label="提报人" width="120" prop="user.en_user_name" align="center"/>
					<el-table-column label="提报时间" width="180" prop="created_at" align="center"/>
				</el-table>
				<div v-if="total>limit" class="page">
					<el-pagination background :page-size="limit" layout="prev, pager, next" :total="total"
						@current-change='changePage'>
					</el-pagination>
				</div>
			</div>
		</div>
		
	</div>
</template>

<script>
	export default {
		name:'subsidyDetail',
		data() {
			return {
				page: 1,
				total: 0,
				loading: false,
				list: [],
				limit: 10,
			}
		},
		props:{
			//控制插件显示
			visible: {
				type: Boolean,
				default: false
			},
			batchId:{
				type:[Number,String],
				default:''
			}
		},
		created() {
			this.getList()
		},
		methods: {
			getList(){
				this.loading = true
				let data={
					page: this.page,
					limit: this.limit,
					batch_id:this.batchId
					// policy_id:this.policy_id,
				}
				this.$axios.get('/api/client/ES/Policys/repartPolicyDetails', {params: data}).then(res => {
					this.loading = false
					if (res.code == 200) {
						this.total = res.data.total
						this.list = res.data.data
					} else {
						this.$eltips(res.msg, 'error')
					}
				})
			},
			changePage(e) {
				console.log(e, '---e')
				this.page = e
				this.getList()
			},
			hideComponents(){
				this.$emit('update:visible',false)
			}
		}
	}
</script>

<style lang="scss" scoped>
	.subsidyDetail{
		.policyAdminCon{
			width: 1200px;
			margin: 0 auto;
			position: relative;
			z-index: 2;
			.head{
				background-color: #FFF;
				margin-bottom: 16px;
				padding:18px 28px;
				border-radius: 16px;
				display: flex;
				align-items: center;
				justify-content: space-between;
				.title {
					color: #151515;
					font-size: 16px;
					span{
						display: inline-block;
						font-weight: bold;
						padding-right: 18px;
						margin-right: 18px;
						border-right: 1px solid #999;
						cursor: pointer;
					}
				}
			}
			
			.page {
				display: flex;
				align-items: center;
				justify-content: center;
				margin: 18px 0 0;
			}
		
		    .ul{
				padding: 18px 28px;
				background: #FFFFFF;
				border-radius: 16px;
			}
		}
	}
</style>